import request from './request'

export function listTool(data) {
  return request.post('/mes/tools/list', data)
}
export function selectTool() {
  return request.get('/mes/tools/select')
}
export function getTool(id) {
  return request.get('/mes/tools/' + id)
}
export function saveTool(data) {
  return request.post('/mes/tools', data)
}
export function updateTool(data) {
  return request.post('/mes/tools/update', data)
}
export function deleteTool(ids) {
  return request.post('/mes/tools/delete', ids)
}
